import React from 'react'
import './aibutton.css'
import StatusContext from '../../../contexts/StatusContext'
import CompareAIContext from '../../../contexts/CompareAIContext'
import { CustomTooltip } from '../customtooltip/CustomTooltip';


export const AIButton = ({pane, provider, model}) => {
 

  let {
    isMe,
    changeLanguage,
    setShowModels,
    activePane,
  
  } = React.useContext(StatusContext);
  
  let {
    saveActivePane,
  } = React.useContext(CompareAIContext);

  
  const handleModels = () => {
    saveActivePane(pane)
    setShowModels(true)
  }

 
  return (
    
    <div className = 'flex-container'>
      {
        isMe() &&

      <CustomTooltip title={changeLanguage('status', 'selectmodel')}>
        <span>
          <label className={`${activePane !== pane ? 'aiSelectModel' : 'aiSelectModelFocus'} ${activePane === 1 ? 'aiSelectModelFocus' : ''}`}
                 onClick={handleModels} > 
                {provider}</label>
        </span>
      </CustomTooltip>
      }         
    </div>  

  )
}

AIButton.defoltProps = {
  pane: 0,
  provider: 'DeepSeek',
  model: 'deepseek-v4-flash',
}


export default AIButton



